<template>
    <div class="about">
        <h1 class="h1 text-center"><br><!--Домашнє завдання--></h1>

        <div class="row">
            <div class="col mx-auto">
<!--                <video-search @afterVideoSearch="afterVideoSearch"></video-search>-->

<!--            <div class="table-responsive">...</div>    -->
                <table class="table table-hover table-dark__">
                    <thead class="thead-dark_" style="color: #fff; background-color: rgb(52 58 64 / 90%)">
                        <tr>
                            <th scope="col">Галузь</th>
                            <th scope="col">Тема</th>
                            <th scope="col">Матеріал</th>
                            <th scope="col">Дата</th>
                            <!--<th scope="col">Пакет</th>-->
                            <th scope="col">...</th>
                        </tr>
                    </thead>
                    <tbody class="bg-light_" style="background-color: #ffffffb3;">
                        <tr v-for="task in tasks" :key="task.id" :class="{'is-verified': task.is_verified}" :title="task.is_verified ? 'Завдання перевірене вчителем' : ''"> <!--table-success-->
                            <td>{{ task.package.material.topic.subject.name }}</td>
                            <td>{{ task.package.material.topic.title }}</td>
                            <td>
                                <a href="#" @click="openPackage(task.package.code)" title="Відкрити завдання">{{ task.package.material.title }}</a>
                            </td>
                            <td>
                                <span style="white-space: nowrap">{{ new Date(task.created_at).toISOString().split('T')[0] }}</span>
                            </td>
                            <!--<td>
                                <a href="#" @click="openPackage(task.package.code)">{{ task.package.code }}</a>
                            </td>-->
                            <td>
                                <template v-if="!task.reply">
                                    <!--<form enctype="multipart/form-data" novalidate></form>-->
                                    <input type="file" @change="uploadReplyFile($event, task)" accept="image/*, .pdf" style="width: 0"><!-- multiple -->
                                    <!--<input id="max_file_size" ref="max_file_size" type="hidden" name="MAX_FILE_SIZE" :value="maxFileSize" />-->
                                    <button type="button" class="btn btn-warning" title="Завантажити фото-відповідь на завдання" @click="selectReplyFile">
                                        <mdb-icon icon="save" />
                                    </button>
                                </template>
                                <template v-else>
                                    <a type="button" class="btn btn-success" title="Переглянути Вашу фото-відповідь" :href="task.reply.file_url" target="_blank">
                                        <mdb-icon icon="image" />
                                    </a>
                                    <button type="button" class="btn btn-danger ml-1" title="Завдання перевірене вчителем. Не можливо видалити "
                                       @click="deleteReplyFile($event, task)"
                                        v-if="!task.is_verified"
                                       :disabled="task.is_verified">
                                        <mdb-icon icon="trash" />
                                    </button>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <modal-package v-if="packageCode" :code="packageCode" @close="packageCode = ''" style="top: 100px"></modal-package>
    </div>
</template>

<script>
    import api from '@/core/api';

    export default {
        name: 'tasks-page',
        data() {
            return {
                maxFileSizeMb: 3,
                //authCode: this.$store.state.auth.code,
                student: {},
                tasks: [],
                packageCode: '',
            }
        },
        computed: {
            maxFileSize() { return this.maxFileSizeMb * 1048576 },
        },
        mounted() {
            this.loadStudent();
        },
        methods: {
            loadStudent() {
                api.get(`students/me`).then(response => {
                    this.student = response.data.student;

                    // @todo Отрефакторить на события. Лучше вынести в $store
                    if (this.student.id) {
                        this.loadTasks();
                    }
                    //this.$emit('afterVideoSearch', this.packageItem);
                });
            },
            loadTasks() {
                const params = {};
                api.get('tasks/me', {params}).then(response => {
                    this.tasks = response.data.tasks;
                });
            },
            openPackage(packageCode) {
                this.packageCode = packageCode;
            },
            selectReplyFile(e) {
                console.log('selectReplyFile', e);
                e.target.closest('button').previousElementSibling.click();
            },
            uploadReplyFile(e, task) {
                console.log('uploadReplyFile', e);
                const file = e.target.files[0]; // file.type
                const fileSizeReadable = this.getFileSizeReadable(file);

                if (!file) return this.$notify({type: 'error', duration: 10000, text: `Помилка вибору файлу для завантаження`});
                if (file.size > this.maxFileSize) {
                    e.target.value = ''; // reset selected file
                    return this.$notify({
                        type: 'error',
                        duration: 20000,
                        text: `Занадто великий розмір файлу: ${fileSizeReadable}.<br>Допустимий розмір ${this.maxFileSizeMb} МБ.<br>
                               Будь ласка, зменьшіть в налаштунках камери або в редакторі розмір полотна зображення.`,
                    });
                }

                const formData = new FormData();
                formData.append('file', file, file.name);

                api.post(`/tasks/${task.id}/reply`, formData, {headers: { "Content-Type": "multipart/form-data" }}).then(response => {
                    if (response.data.success) {
                        this.$notify({type: 'success', text: response.data.message});
                    } else {
                        this.$notify({type: 'error', duration: 10000, text: response.data.message});
                    }

                    this.loadTasks();
                }).catch(err => {
                    e.target.value = ''; // reset selected file
                    let msg = (err.response && err.response.data.message) ? err.response.data.message : `Виникла помилка! ${err.response.statusMessage}`;
                    this.$notify({type: 'error', duration: 10000, text: msg});
                });
            },
            getFileSizeReadable(file) {
                const size = file ? file.size : 0;
                if (size < 1024) {
                    return size + ' байт';
                } else if(size > 1024 && size < 1048576) {
                    return (size/1024).toFixed(1) + ' КБ';
                } else if(size > 1048576) {
                    return (size/1048576).toFixed(1) + ' МБ';
                }
            },
            deleteReplyFile(e, task) {
                const reply = task.reply;

                if (!confirm(`Видалити відповідь?`)) {
                    return;
                }

                api.delete(`/reply/${reply.id}`).then(response => {
                    console.log(response);
                    // @todo Обработать ошибки
                    this.loadTasks();
                });
            }
        }
    }
</script>

<style scoped>
.table th, .table td { vertical-align: middle; }
.table tr.is-verified { background-color: #c1d7a5; }
</style>
